import { Collapse, Tooltip } from "bootstrap";
import { createApp } from "vue";
import Store from "../Store";
import hash from "../hash";
import { may, traduit } from "./composant/b2bLangue";

import html from "./sidebar.html";

const js = {
  url: function (echangeur) {
    echangeur.addAction("b2b.env.list", { filter: true }, "", "universe");

    const u = hash.toArray()[0].par.u;
    if (u) echangeur.addAction("b2b.env.get", { u }, "", "stocks");
  },

  onLoad: function (echangeur) {
    let THIS = this;
    this.onstock =
      echangeur.stocks &&
      echangeur.stocks.tocs &&
      echangeur.stocks.tocs.filter((u) => u.onstock === true).length > 0;

    let univer = [];
    for (const u of echangeur.universe.rows) univer.push(u.k);

    //Récupération du CTX
    const ctx = Store.get("CTX");
    //u est l'univers en cours de consultation
    const u = hash.toArray()[0].par.u; 
    ctx.univer = u; 
    ctx.univerList = echangeur.universe.rows;

    //Variable qui trouve l'univers en cours de consultation dans le tableau d'univers "univerlist"
    const currentUniverse = ctx.univerList.find(univ => univ.k === u);
    this.isEdi = (currentUniverse && currentUniverse.edi===true) &&  (ctx.session && ctx.session.isEdi) ;  

    const links = [];
    const addLink = (title, href, icon, hidden, txt) => {
      console.log(title)
      links.push({
        txt:txt,
        title: traduit(title + "/title", "global"),
        href,
        icon: icon !== "no-icon" ? `fa-light ${icon}` : "",
        hidden,
      });
    };
    
    console.log(ctx)

    const app = createApp({
      data: function () {
        addLink("start", "#home", "fa-home");
        // addLink('universe', '#universe', 'fa-globe');
        addLink("linelists", "#env", "fa-list");
        if (may("CREORD")) addLink("orderList", "#orderList", "fa-cart-shopping");
        
        addLink("edi", "#edi", "no-icon", !THIS.isEdi, "EDI");

        if (may("MAJBRAND"))   addLink("brandnameList", "#brandnameList", "fa-address-book");
        if (may("MAJSEASON") ) addLink("marketSetup", "#seasonList", "fa-shop");
        if (may("MENUTRI"))    addLink("codification", "#codification", "fa-arrow-down-arrow-up");
        if (may("MAJSAVETHE")) addLink("savethe", "#savethe", "fa-bell");
        addLink( "importstock",  "#importstock", "fa-arrow-down-to-square ", !THIS.onstock );
        //if (may("MAJSAVETHE")) addLink('importproduct', '#importproduct', 'fa-arrow-down-to-square');
        if (may("ARCHIVES")) addLink("archives", "#archives", "fa-box-archive");
        if (may("MAJSAVETHE")) addLink("tasks", "#tasks", "fa-clipboard-check");
        if (may("USERS")) addLink("users", "#users", "fa-user");
        if (may("GROUPS")) addLink("groups", "#groups", "fa-users");
        if (may("MENUADM")) addLink("admin", "dmkadmin.html#", "fa-gear");

        return {
          activeId: "",
          link: links,
          profil: {},
          user: echangeur.hash,
          collapse: null,
          hasStock: THIS.onstock,
          isEdi: THIS.isEdi,
        };
      },
      computed: {
        isPretenom() {
          return this.user.realuser !== this.user.username;
        },
      },
      watch: {
        hasStock: function (e) {
          this.hasStock = e;
          console.log("stock change", e);
        },
        isEdi: function (e) {
          const ctx = Store.get("CTX");
          this.isEdi = (e && ctx.session && ctx.session.isEdi) ;
          console.log("isEdi change", e);
        }
      },
      methods: {
        t(value) {
          return traduit(value, "sidebar");
        },

        navbarEvent() {
          this.collapse.hide();
        },

        selectLink(href, id) {
          this.activeId = id;
          const univer = hash.toArray()[0].par.u;
          window.location.href = univer ? `${href}&u=${univer}` : "#universe";
        },

        async logout() {
          window.location.href = "#logout";
        },

        async myAccount() {
          window.location.href = "#myAccount";
        },

        unpretenom() {
          const url = `${window.location}`;
          window.location.assign(url.split("?")[0]);
        },

        hashToLink() {
          const url = hash.toArray()[0].hash;
          this.activeId =
            this.link.find((a) => a.href === "#" + url)?.title ??
            this.link[0].title;
        },
        refreshUnivers(a) {
          console.log("refreshUniver VUEJS");
          this.hasStock = false;
          console.log("refreshUnivers",a )
          if (a && a.k) this.hasStock = a.onstock;
          console.log(`onstock : ${this.onstock}`);
        },
      },

      async mounted() {
        this.hashToLink();

        new Tooltip(document.body, {
          selector: "[data-bs-toggle='tooltip']",
          trigger: "hover",
        });

        this.collapse = new Collapse(
          document.getElementById("sidebarSmallCollapse"),
          {
            toggle: false,
          }
        );
      },
    });
    this.mv = app.mount(THIS.c$("._vueChargement")[0]);
  },

  externalfunc: function (e) {
    console.log("externalfunc",e)
    console.log("edi",e.edi)
    this.univer = e;
    this.mv.$data.hasStock = e.onstock;
    this.mv.$data.isEdi = e.edi;
  },
};

export default {
  sidebar: { js, html },
};
